import { render, staticRenderFns } from "./hrd-trainee-view-course.vue?vue&type=template&id=bf713c4a&scoped=true"
import script from "./hrd-trainee-view-course.vue?vue&type=script&lang=js"
export * from "./hrd-trainee-view-course.vue?vue&type=script&lang=js"
import style0 from "./hrd-trainee-view-course.vue?vue&type=style&index=0&id=bf713c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf713c4a",
  null
  
)

export default component.exports